module.exports = __webpack_public_path__ + "t.no1.f82174c9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/aoyama/child_to_parent/t.no1.jpg
// module id = OLlQ
// module chunks = 0